const mockData = {
    mockCardOne: {
        strength: 10,
        defense: 20,
        stamina: 10,
        speed: 90,  
        level: 1,
        name: 'Bit Mac',
        element: 'warrior',
        dna: 'new_gen-0',
        imgUrl: '/static/card_bit_mac.png',
    },
    mockCardTwo: {
        strength: 15,
        defense: 20,
        stamina: 87,
        speed: 20,      
        level: 1,
        name: 'Icy Hot',
        element: 'mystic',
        dna: 'new_gen-0',
        imgUrl: '/static/card_icy_hot.png'
    },
    mockCardThree: {
        strength: 15,
        defense: 10,
        stamina: 97,
        speed: 90,
        level: 10,
        name: 'Magic',
        element: 'magician',
        dna: 'new_gen-0',
        imgUrl: '/static/card_magic.png'
    }
};

export const GENX_mockData = {
    cardOne: {
        strength: 77,
        defense: 77,
        stamina: 77,
        speed: 77,  
        level: 10,
        name: 'Costume Flame',
        element: 'mystic',
        dna: 'new_gen-x',
        imgUrl: '/static/card_costume_flame.png',
    },
    cardTwo: {
        strength: 90,
        defense: 30,
        stamina: 90,
        speed: 30,      
        level: 8,
        name: 'Set Attack',
        element: 'luminous',
        dna: 'new_gen-x',
        imgUrl: '/static/card_set_attack.png'
    },
    cardThree: {
        strength: 50,
        defense: 50,
        stamina: 50,
        speed: 50,
        level: 5,
        name: 'Aero Sweep',
        element: 'warrior',
        dna: 'new_gen-x',
        imgUrl: '/static/card_aero_sweep.png'
    }
};

export default mockData;




// WEBPACK FOOTER //
// ./src/util/constants/mockData.js